/**
 * Common constants for UI components
 *
 * Centralized common constants used across the application.
 */

export const COMMON_CONSTANTS = {
  /** Debounce delay for search text input in milliseconds */
  searchTextDebounce: 300,
  /**
   * `platform` value sent to the setLastSeenTimestamp Cloud Function. Flutter sends the host-OS
   * TargetPlatform ordinal (main_screen.dart:162); web has no faithful equivalent, so we send the
   * server's own "unspecified platform" default sentinel -1 (set_last_seen_timestamp.ts:16).
   *
   * Lives here, not in Remote Config: it describes the web client itself, so it is a fixed
   * protocol sentinel rather than a server-tunable value (see `domain/enums/remoteConfigs.ts`,
   * which deliberately omits it from `RemoteConfigKey`).
   */
  webPlatformCode: -1,
} as const;

export type CommonConstants = typeof COMMON_CONSTANTS;
